import Button from 'components/generics/buttons/Button';
import { FlowComponentProps } from 'components/generics/flows/Flow';
import Typography from 'components/generics/texts/Typography';
import NewTabLink from 'components/next/NewTabLink';
import React from 'react';
import classes from './index.module.scss';

const FINRA_LINK =
  'https://www.finra.org/rules-guidance/key-topics/books-records#:~:text=In%20addition%2C%20FINRA%20Rule%204511,rules%20or%20applicable%20SEA%20rules';

const DeleteAccountConfirm = ({ onFinish, loading }: FlowComponentProps) => {
  return (
    <>
      <Typography className={classes.title}>Deactivate your account</Typography>
      <Typography className={classes.subtitle}>
        Deactivating your account means that your custodial account will be
        closed. You will not receive dividends and will not be able to invest.
        Your personal information will be deleted after six years.{' '}
        <NewTabLink
          to={FINRA_LINK}
          className={classes.link}
        >
          Learn More
        </NewTabLink>
      </Typography>
      <Typography className={classes.subtitle}>
        You can still access your legal docs in the app.
      </Typography>
      <Button
        loading={loading}
        className={classes.button}
        onClick={onFinish}
      >
        Confirm
      </Button>
    </>
  );
};

export default DeleteAccountConfirm;
